// pluralise — render-time helpers for years/months/extension-period
// strings. Defensive against malformed input: clamps negative values to a
// neutral "0 years" rather than throwing, so a corrupt extension period
// can never crash the contract overview surface.

export function pluraliseYears(n: number): string {
  return `${n} ${n === 1 ? "year" : "years"}`;
}

export function pluraliseMonths(n: number): string {
  return `${n} ${n === 1 ? "month" : "months"}`;
}

interface ExtensionPeriodInput {
  years: number;
  months: number;
}

export function pluraliseExtensionPeriod({
  years,
  months,
}: ExtensionPeriodInput): string {
  if (years < 0 || months < 0) return "0 years";
  if (years === 0 && months === 0) return "0 years";
  if (years > 0 && months === 0) return pluraliseYears(years);
  if (years === 0 && months > 0) return pluraliseMonths(months);
  return `${pluraliseYears(years)}, ${pluraliseMonths(months)}`;
}
